module.exports = __webpack_public_path__ + "static/media/pause.df24c737.png";